export const calendar = {
  title: "التقويم",
  subtitle: "أدِر حجوزات وحدات إقامتك",
  createBooking: "إنشاء حجز",
  propertyLabel: "وحدة الإقامة",
  searchPlaceholder: "ابحث عن وحدة إقامة",
  filterByProperty: "تصفية وحدات الإقامة",
  clearFilters: "مسح عوامل التصفية",
  loadingMore: "جارٍ تحميل المزيد من التواريخ…",

  payment: {
    "pending":  "بانتظار الدفع",
    "paid":     "مدفوع",
    "rejected": "الدفع مرفوض",
    "refunded": "مُسترَد",
    "partial":  "دفع جزئي"
  },

  tooltips: {
    noChannels: "غير متصل بأي قناة",
    connectedTo: "متصل بـ: {channels}",
    manual: "WA Checkin (يدوي)",
    other: "قناة أخرى",
    configPrices: "إعداد الأسعار",
  },

  errors: {
    loadCalendar: "خطأ في تحميل بيانات التقويم",
    updateViewAfterCancel: "خطأ في تحديث العرض بعد الإلغاء",
    closeDates: "خطأ في إغلاق التواريخ",
    deleteClosedDates: "خطأ في حذف التواريخ المغلقة",
    updateClosedDates: "خطأ في تحديث التواريخ المغلقة",
  },

  filters: {
    showPrices: "عرض الأسعار",
    today: "اليوم",
    multi: "متعدد",
    monthly: "شهري",
    prevMonthAria: "الشهر السابق",
    nextMonthAria: "الشهر التالي",
  },

  actions: {
    title: "اختر إجراءً",
    question: "ماذا تريد أن تفعل بالتواريخ المحددة؟",
    createBooking: "إنشاء حجز",
    blockDates: "إغلاق التاريخ",
    editNightPrice: "تعديل سعر الليلة",
    editMinStay: "الحد الأدنى لمدة الإقامة",
    editMinStayHint: "حدّد الحد الأدنى لعدد الليالي لكل تاريخ",
  },
  minStayModal: {
    description:
      "حدّد الحد الأدنى لمدة الإقامة لنطاق التواريخ المحدد. لن يؤثر ذلك على الأسعار الحالية.",
    success: "تم تحديث الحد الأدنى لمدة الإقامة بنجاح",
    hint: "الحد الأدنى لعدد الليالي التي يجب أن يحجزها الضيف.",
    errors: {
      minOne: "يجب أن يكون الحد الأدنى لمدة الإقامة ليلة واحدة على الأقل.",
    },
  },

  fields: {
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
  },

  buttons: {
    delete: "حذف",
    cancel: "إلغاء",
    save: "حفظ",
    close: "إغلاق",
    saveChanges: "حفظ التغييرات",
    closeDates: "إغلاق التواريخ",
  },

  closeModal: {
    headerCreate: "إغلاق التواريخ",
    headerEdit: "تعديل التواريخ المغلقة",
  },

  priceModal: {
    description:
      "هذا تغيير يدوي على السعر الذي تختاره. كل ما تغيّره هنا سيؤثر فقط على وحدة الإقامة هذه ونطاق التواريخ هذا.",
    periodLabel: "فترة التواريخ",
    startPlaceholder: "تاريخ البدء",
    endPlaceholder: "تاريخ الانتهاء",
    pricePerNight: "السعر لكل ليلة",
    minStay: "الحد الأدنى لمدة الإقامة",
    minNightsPlaceholder: "الحد الأدنى للّيالي",
    pricePlaceholder: "السعر للنطاق المحدد",
    success: "تم تحديث الأسعار بنجاح",
    errors: {
      invalidRange: "يجب تحديد نطاق تواريخ صالح",
      startAfterEnd: "لا يمكن أن يكون تاريخ البدء بعد تاريخ الانتهاء",
      minStay:
        "الحد الأدنى لمدة الإقامة هو {min} ليالٍ، لكن النطاق المحدد يحتوي على {nights} ليالٍ",
      missingSelection: "لم يتم تحديد أي وحدة إقامة أو نطاق تواريخ",
      request: "خطأ في الطلب: {msg}",
      update: "خطأ في تحديث الأسعار: {msg}",
    },
  },

  details: {
    header: "تفاصيل الحجز",
    title: "الحجز",
    createdOn: "أُنشئ في {date}",
    checkIn: "تسجيل الوصول",
    checkOut: "تسجيل المغادرة",
    arrow: "→",
    statusLabel: "الحالة",
    status: {
      booked: "محجوز",
      blocked: "مغلق",
    },
    night_one: "ليلة",
    night_other: "ليالٍ",
    actions: {
      view: "عرض الحجز",
      changeRoom: "تغيير الغرفة",
      cancel: "إلغاء الحجز",
    },
  },
};

export default calendar;
